import Handlebars from 'lib/handlebars.runtime-v4.7.8';
import { accounting } from 'lib/accounting';

export default Handlebars.registerHelper('formatMoney', function formatMoney(num) {
  return accounting.formatMoney(num);
});
